import UploaderWithCropper from "./UploaderWithCropper";
export default UploaderWithCropper;
